import template from '../../pug/social-share.pug';

const socialData = {
    list: [
        // {
        //     name: 'facebook',
        //     url(pageUrl) {
        //         return `https://www.facebook.com/sharer.php?src=sp&u=${pageUrl}&title=&utm_source=share2`
        //     }
        // },
        {
            name: 'vkontakte',
            url(pageUrl, pageTitle) {
                return `https://vk.com/share.php?url=${pageUrl}&utm_source=vgtrk_share`
            }
        },
        // {
        //     name: 'twitter',
        //     url(pageUrl) {
        //         return `https://twitter.com/intent/tweet?url=${pageUrl}&utm_source=share2`
        //     }
        // },
        {
            name: 'odnoklassniki',
            url(pageUrl, pageTitle) {
                return `https://connect.ok.ru/offer?url=${pageUrl}&utm_source=share2`
            }
        },
        {
            name: 'telegram',
            url(pageUrl, pageTitle) {
                return `https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`
            }
        }
        // {
        //     name: 'flipboard',
        //     url(pageUrl) {
        //         return `https://share.flipboard.com/bookmarklet/popout?v=2&title=&url=${pageUrl}utm_campaign=tools&utm_medium=article-share&utm_source=www.vesti.ru`
        //     }
        // }
    ]

};

const list = (pageUrl, pageTitle) => {
    let url  = encodeURI(pageUrl)
    let title  = encodeURI(pageTitle)
    return socialData.list.map(item => {
        return {
            name: item.name,
            url:  item.url(url, title)
        }
    })
};

export default class SocialShare {
    constructor($place, url, title) {
        let socialData   = {
            list: list(url, title),
            setClassName(name) {
                return `share__link share__link--${name}`
            }
        };
        $place.innerHTML = template({ socialData })
    }
}
